import { divIcon, icon, LatLngBounds } from 'leaflet'
import defaultIcon from './mapMarker.png'
import iconShadow from 'leaflet/dist/images/marker-shadow.png'

export const calcRadius = (score?: number) =>
  score ? Math.sqrt(score / 3.1415) * 1000 : 0

export const boundsIn = (
  boundary: LatLngBounds | null,
  latitude: number,
  longitude: number,
  radius = 0
) => {
  if (!boundary) return false
  if (radius === 0) return boundary.contains([latitude, longitude])
  const r = {
    n: latitude - radius,
    s: latitude + radius,
    w: longitude - radius,
    e: longitude + radius,
  }
  const b = {
    n: boundary.getNorth(),
    s: boundary.getSouth(),
    w: boundary.getWest(),
    e: boundary.getEast(),
  }
  if (
    ((b.n <= r.n && b.s >= r.n) || (b.n <= r.s && b.s >= r.n) || (b.n > r.n && b.s < r.s)) &&
    ((b.w <= r.w && b.e >= r.w) || (b.w <= r.e && b.e >= r.e) || (b.w > r.w && b.e < r.e))
  ) return true
  return false
}

export const dummyPin = () => divIcon({ html: '<div class="marker-dummy">' })

export const activePin = icon({
  iconUrl: defaultIcon,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12.5, 40],
  popupAnchor: [0, -45],
})

export const inActivePin = divIcon({
  html: `<div class="marker-cluster single"><span>1</span></div>`,
})

export const clusterPin = (size: number) => {
  const className = size < 7 ? 'small' : size < 15 ? 'medium' : size < 30 ? 'large' : 'extra'
  return divIcon({
    html: `<div class="marker-cluster ${className}"><span>${size}</span></div>`,
  })
}
